import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import LottieView from "lottie-react";
import classes from "./CooperationCenterDetail.module.css";
import classerror from "../../../shared/pages/Error404Page.module.css";
import Error404Animation from "../../../shared/assets/animated-placeholders/Error404.json";
import { testUrl } from "../BaseData";

const CooperationCenterDetail = () => {
  const navigate = useNavigate();
  const { short_name } = useParams();
  const { t, i18n } = useTranslation();
  const [center, setCenter] = useState(null);
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCenterData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(testUrl + `/api/cooperation-centers/${short_name}/`);
        setCenter(response.data.center);
        setCenters(response.data.centers);
      } catch (err) {
        console.error("Error fetching center data:", err);
        setError("Ma'lumotlarni yuklashda xatolik");
      } finally {
        setLoading(false);
      }
    };

    fetchCenterData();
  }, [short_name]);

  const getCenterName = (centerData) => {
    if (!centerData) return t("no_name_available");
    return centerData[`name_${i18n.language}`] || centerData.name_uz || t("no_name_available");
  };

  if (loading) return <p>Yuklanmoqda...</p>;

  if (error || !center) {
    return (
      <div className={classerror["error-page"]}>
        <LottieView
          className={classerror["animation"]}
          animationData={Error404Animation}
          loop={true}
        />
        <p className={classerror["title"]}>{t("sorry")}</p>
        <p className={classerror["description"]}>{t("back_main")}</p>
        <div onClick={() => navigate("/")} className={classerror["button"]}>
          {t("main_menu")}
        </div>
      </div>
    );
  }

  return (
    <div className={classes.mainContainer}>
      <div className={classes["sidebar-wrapper"]}>
        <div className={classes.sidebar}>
          <h3>{t("Xorijiy hamkorlik markazlari")}</h3>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {centers && centers.length > 0 ? (
              centers.map((c, index) => (
                <li
                  onClick={() => navigate(`/cooperation-centers/${c.short_name}`)}
                  key={c.id}
                  style={{ marginBottom: "10px" }}
                  className={c.short_name === short_name ? classes.active : ""}
                >
                  <span
                    style={{
                      marginRight: "8px",
                      color: "#133654",
                      fontWeight: "bold",
                    }}
                  >
                    {index + 1}.
                  </span>
                  <span style={{ cursor: "pointer", color: "#133654" }}>
                    {getCenterName(c)}
                  </span>
                </li>
              ))
            ) : (
              <li>{t("no_centers_found")}</li>
            )}
          </ul>
        </div>
      </div>

      <div data-aos="fade-up" className={classes["content-container"]}>
        <h1 className={classes["page-title"]}>{getCenterName(center)}</h1>
        <div
          className="ck-content"
          dangerouslySetInnerHTML={{
            __html: center[`content_${i18n.language}`] || "",
          }}
        />
      </div>
    </div>
  );
};

export default CooperationCenterDetail;
